/*
 * @Author: Morningsun 1049935747@qq.com
 * @Date: 2025-07-07 10:27:48
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-08-05 11:50:23
 * @Description: 
 */

import { createRouter, createWebHashHistory } from 'vue-router'
//import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHashHistory(''),
  routes: [
    {
      path: '/',
      name: '',
      component: () => import('@/components/Root.vue')
    },
    {
      path: '/tudialog',
      name: 'tudialog',
      component: () => import('@/components/TuDialog.vue')
    },
    {
      path: '/flowTest',
      name: 'flowTest',
      component: () => import('@/components/FlowChart.vue')
    },
    {
      path: '/txFlow',
      name: 'txFlow',
      component: () => import('@/components/TXFlowChart.vue')
    },
    {
      path: '/tsFlow',
      name: 'tsFlow',
      component: () => import('@/components/TSFlowChart.vue')
    },
    {
      path: '/aiChat',
      name: 'aiChat',
      component: () => import('@/views/home/home.vue')
    },
    {
      path: '/markMap',
      name: 'markMap',
      component: () => import('@/components/MarkMap.vue')
    },
    {
      path: '/setting',
      name: 'setting',
      component: () => import('@/views/SettingsPage.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/Login.vue')
    }

  ]
})

export default router
